import { render } from "./GallerySection.vue?vue&type=template&id=f3b3bcbc&scoped=true"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"

import "./GallerySection.vue?vue&type=style&index=0&id=f3b3bcbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b3bcbc"]])

export default __exports__